import $ from 'jquery';
import loadScript from 'load-script';
import * as ajax from './ajax';

export default function Popup($popupEl) {
  this.$el = $popupEl;
  this.$contentEl = $($popupEl.find(`.${Popup.CSS_CONTENT}`));
  this.$contentContainerEl = $($popupEl.find(`.${Popup.CSS_CONTENT_CONTAINER}`));
  this.$loadingEl = $($popupEl.find(`.${Popup.CSS_LOADING}`));
  this.isOpen = false;
}

Popup.CSS_OPEN = 'popup-open';
Popup.CSS_CONTENT = 'popup--content';
Popup.CSS_CONTENT_CONTAINER = 'popup--content-container';
Popup.CSS_LOADING = 'popup--loading';
Popup.CSS_OTHER_CONTENT = 'layout--body';
Popup.CSS_NOSCROLL = 'noscroll';

function stripAndExecuteScript(text) {
  const srcs = [];
  const inlineSrcs = [];
  const scriptTag = /<script src="([^"]+)"><\/script>/gi;
  const inlineScript = /<script>(.*)<\/script>/gi;

  let cleaned = text.replace(scriptTag, (_, src) => {
    srcs.push(src);
    return '';
  });

  cleaned = cleaned.replace(inlineScript, (_, src) => {
    inlineSrcs.push(src);
    return '';
  });

  for (let i = 0; i < srcs.length; i++) {
    loadScript(ajax.bustCache(srcs[i]));
  }

  for (let j = 0; j < inlineSrcs.length; j++) {
    loadScript(inlineSrcs[j]);
  }

  return cleaned;
}

Popup.prototype.open = function (options) {
  if (this.isOpen) {
    console.error('Popup: Tried to open popup, but a popup is already open.');
    return;
  }

  this.isOpen = true;
  this.popupClass = options.popupClass || '';

  this.$el.addClass(Popup.CSS_OPEN);
  $('body').addClass(Popup.CSS_NOSCROLL);

  this.loadContent(options.href);
};

Popup.prototype.loadContent = function (href) {
  const isInlineHtmlContent = (href.indexOf('#') === 0);
  if (isInlineHtmlContent) {
    this.loadHtmlContent(href.replace('#', ''));
  } else {
    this.loadAjaxContent(href);
  }
};

Popup.prototype.loadHtmlContent = function (id) {
  const el = document.getElementById(id);
  this.showContent(el.innerHTML);
};

Popup.prototype.loadAjaxContent = function (href) {
  const self = this;
  ajax.getWithoutCache(href, (err, res) => {
    if (err && err.crossDomain) {
      window.location.reload(true);
      return;
    }
    if (typeof res === 'undefined' || res.status !== 200) {
      if (res && res.body.error) {
        self.showContent(res.body.message);
      } else {
        self.showContent('En intern feil har oppstått.');
      }
      return;
    }
    const content = res.text;
    self.showContent(content);
  });
};

Popup.prototype.showContent = function (content) {
  this.$el.addClass(Popup.CSS_OPEN);
  $('body').addClass(Popup.CSS_NOSCROLL);
  this.isOpen = true;

  this.$loadingEl.hide();
  this.$contentContainerEl.addClass(this.popupClass);
  this.$contentEl.html(stripAndExecuteScript(content));
};

Popup.prototype.close = function () {
  if (!this.isOpen) {
    console.error('Popup: Tried to close popup, but no popup is open.');
    return;
  }

  this.isOpen = false;
  this.$el.removeClass(Popup.CSS_OPEN);

  this.$contentEl.empty();
  this.$contentContainerEl.removeClass(this.popupClass);
  $('body').removeClass(Popup.CSS_NOSCROLL);
  this.$loadingEl.show();
};
